import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";
import {toast} from "react-toastify";
import {resolve} from "chart.js/helpers";
import {useSession} from "./AuthReducer";
import {useNavigate} from "react-router-dom";
import {HTTP_410_GONE} from "../../API/Axios/Status";

const initialState = {
    timeLimit: 0,
    name: "",
    title: "",
    num: 0,
}

export const QUESTION_ACTIONS = {
    GET_SINGLE_QUESTION: "GET_SINGLE_QUESTION",
}


const QuestionReducer = (state = initialState, action) => {
    switch (action.type) {
        case QUESTION_ACTIONS.GET_SINGLE_QUESTION:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}


export function useQuestion() {
    const dispatch = useDispatch();
    const state = useSelector(state => state.QuestionReducer);
    const [isLoading, setIsLoading] = useState(false);
    const {authActions} = useSession();
    const navigate = useNavigate();
    const loadQuestions = (query) => {
        setIsLoading(true)
        return new Promise((resolve, reject) => {
            axiosInstance.get(URLS.question + query).then((res) => {
                setIsLoading(false)
                dispatch({
                    type: QUESTION_ACTIONS.GET_SINGLE_QUESTION,
                    payload: res.data,
                })
            }).catch((err) => {
                if (err.response.status === HTTP_410_GONE) {
                    authActions.showSubscriptionModal()
                    navigate("/practice")
                    return;
                }
                reject(err);
                setIsLoading(false)
            })
        })
    };
    const convertBlobToText = (blob) => {
        //     convert blob to file.mp3
        let audioBlob = blob.audioBlob
        // 'audio/ogg; codecs=opus'
        let file = new File([audioBlob], 'file.mp3', {type: 'audio/mp3'});
        let formData = new FormData();
        formData.append("audio", audioBlob, "file.mp3");
        return new Promise((resolve, reject) => {
            toast.promise(axiosInstance.post(URLS.convertSpeechToText, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000000
            }), {
                pending: "Getting AI Assessment...",
                error: "Something went wrong whilte converting to text. Please try again.",
            }, {
                hideProgressBar: false,
                toastId: "convert-speech-to-text"
            }).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err);
            })
        })
    }


    const actions = {
        loadQuestions: loadQuestions,
        convertBlobToText: convertBlobToText,

    }


    return {
        question: state,
        questionActions: actions,
        isLoading: isLoading,
    }
}


export default QuestionReducer;
